/* ========================== */  
/* ========= import ========= */  
/* ========================== */ 
/* ====== React ====== */
import React from "react"
/* ====== CSS ====== */
import styled from 'styled-components';
/* ====== Component Js/Jsx ====== */
import { assets } from '03CommonApiParts/Configuration';

/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
const SdivRadioGroup = styled.div`
    /* height:18px; */
    padding:0 5px;
    height: -webkit-fill-available;
    display: flex;
    align-items: center;
`;
const SdivCnfRadioGroup = styled.div`
    display:flex;
    height:24px;
    padding:0 5px;
`;
const SlabelCheck = styled.label`//ラジオボタンのラベル
    margin-right: 10px;
    white-space: nowrap;
    cursor:pointer;
`;
const SinputRadio = styled.input`
    position: relative;
    margin:0 2px;
    top:1px;
    :read-only{
        background-color: "#e9e9e9";
    }
    cursor:pointer;
`;
const SdivRadioCircle = styled.div`
    /* margin-left:6px; */
    border:1px solid red;
    border-radius:50px;
    width: 11px;
    height: 11px;
    margin:6px 2px 0  4px;
    background-color:white;
`;
const SdivMark = styled.div`
    width:7px;
    height:7px;
    margin:2px;
    border-radius:50%;
    background-color:${props=>props.check ? 'red' : 'none'};
`;
/* How To Use 
<TableRadio 
    id={list.value}
    label={list.label}
    disabled={items.disabled}
    value={`${list.value}`}
    defaultChecked={dataRow[items.name] === list.value}
    onClick={() => setValue(`${payload}.${items.name2}`, categoryName.key)}
    register= {register(`${payload}.${items.name}`,
    {
        required: items.required?CFArrayFount(inputCheckMaster.list,'value','required').label:'',
    })}
    // readOnly={items.readOnly}
    />
/> */

/*==================*/
/*=====  Main  =====*/
/*==================*/
export const TableRadio = (props) => {

    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { id,register, label, value, defaultChecked,disabled, onClick,isDirty } = props;

    /*--------------------------*/  
    /*------ Start Render ------*/  
    /*--------------------------*/
    return (
        <SdivRadioGroup>
            <SlabelCheck className='baseText' style={{fontSize: assets().size.baseText}} htmlfor={id}>
                <label style={{backgroundColor: isDirty ? assets().color.yellow : '' ,borderRadius:'50%'}}>
                <SinputRadio
                    {...register}
                    defaultChecked={defaultChecked}
                    // disabled={disabled && !defaultChecked}
                    disabled={disabled}
                    value={value}
                    onClick={onClick}
                    // readOnly={readOnly}
                    type='radio'
                />
                </label>
                {label}
            </SlabelCheck>
        </SdivRadioGroup>
    );
};

/* 確認用のラジオボタン */
export const TableCnfRadio = (props) =>{
    const { value,label } = props;

    return(
        <SdivCnfRadioGroup>
            <SdivRadioCircle check={value}>
                <SdivMark check={value}></SdivMark>
            </SdivRadioCircle>
            {label}
        </SdivCnfRadioGroup>
    )
}